module.exports = __webpack_public_path__ + "static/media/Michelle.9513041e.jpg";